﻿{
  "iceForecastValidFrom": "2018-10-18",
  "iceForecastValidTo": "2018-10-26",
  "forecastRegions": [
    {
      "name": "Østlandet",
      "validFrom": "2018-10-18",
      "validTo": "2018-10-26",
      "iceTableDate": "2018-10-18",
      "url": "https://www.varsom.no/is/isvarsling/regionale-isvarsler/ostlandet/",
      "counties": ["03", "31", "32", "33", "34", "39", "40"]
    },
    {
      "name": "Rogaland - Agder",
      "validFrom": "2018-10-18",
      "validTo": "2018-10-26",
      "iceTableDate": "2018-10-18",
      "url": "https://www.varsom.no/is/isvarsling/regionale-isvarsler/rogaland-agder/",
      "counties": ["42", "11"]
    },
    {
      "name": "Vestland",
      "validFrom": "2018-10-18",
      "validTo": "2018-10-26",
      "iceTableDate": "2018-10-18",
      "url": "https://www.varsom.no/is/isvarsling/regionale-isvarsler/vestland/",
      "counties": ["46"]
    },
    {
      "name": "Trøndelag - Møre og Romsdal",
      "validFrom": "2018-10-18",
      "validTo": "2018-10-26",
      "iceTableDate": "2018-10-18",
      "url": "https://www.varsom.no/is/isvarsling/regionale-isvarsler/trondelag-more-og-romsdal/",
      "counties": ["15", "50"]
    },
    {
      "name": "Nordland",
      "validFrom": "2018-10-18",
      "validTo": "2018-10-26",
      "iceTableDate": "2018-10-18",
      "url": "https://www.varsom.no/is/isvarsling/regionale-isvarsler/nordland/",
      "counties": ["18"]
    },
    {
      "name": "Troms",
      "validFrom": "2018-10-18",
      "validTo": "2018-10-26",
      "iceTableDate": "2018-10-18",
      "url": "https://www.varsom.no/is/isvarsling/regionale-isvarsler/troms/",
      "counties": ["55"]
    },
    {
      "name": "Finnmark",
      "validFrom": "2018-10-18",
      "validTo": "2018-10-26",
      "iceTableDate": "2018-10-18",
      "url": "https://www.varsom.no/is/isvarsling/regionale-isvarsler/finnmark/",
      "counties": ["56"]
    }
  ]
}
